import React, { useState, useEffect } from 'react';
import '../styles/Home/Home.css';
import Hero from '../components/Home/Hero';
import Destinations from '../components/Home/Destinations_notUsed';
import Gallery from '../components/Home/Gallery';
import Packages from '../components/Home/Packages';
import About from '../components/Home/About';
import Testimonials from '../components/Home/Testimonials';
import Whatsapp from '../components/Whatsaapp';
import Footer from '../components/Footer';
import LogoSection from '../components/LogoSection';
import BannerSection from '../components/Home/BannerSection';
import ContactCard from '../components/ContactCard';
import ExploreWorldCategories from '../components/Home/ExploreWorldCategories';
import { fetchTripsByCategory, fetchTripsByLocation } from '../functions/FetchTrips';
import DesktopCategories from '../components/Home/DesktopCategories';
import UpcomingTrips from '../components/Home/UpcomingTrips';
import Plans from '../components/Home/Plans';

const Home = () => {
  // Add state to track whether to show the contact card
  const [showContactCard, setShowContactCard] = useState(false);

  // State for different package categories
  const [backpackTours, setBackpackTours] = useState([]);
  const [groupTours, setGroupTours] = useState([]);
  const [upcomingTours, setUpcomingTours] = useState([]);
  const [popularDestinations, setPopularDestinations] = useState([]);
  const [indiaTrips, setIndiaTrips] = useState([]);
  const [loading, setLoading] = useState(true);

  // Set a timer to show the contact card after a delay
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowContactCard(true);
    }, 30000); // Show after 30 seconds (adjusted from 15 seconds)

    return () => clearTimeout(timer); // Cleanup on unmount
  }, []);

  // Fetch categorized data from Firebase
  useEffect(() => {
    const fetchCategorizedData = async () => {
      try {
        setLoading(true);

        // Fetch data for each category
        const [backpack, group, upcoming, popular] = await Promise.all([
          fetchTripsByCategory('backpack'),
          fetchTripsByCategory('group'),
          fetchTripsByCategory('upcoming'),
          fetchTripsByCategory('popular')
        ]);

        setBackpackTours(backpack);
        setGroupTours(group);
        setUpcomingTours(upcoming);
        setPopularDestinations(popular);

      } catch (error) {
        console.error('Error fetching categorized trips:', error);
        // Keep empty arrays as fallback
      } finally {
        setLoading(false);
      }
    };

    fetchCategorizedData();
  }, []);

  // Fetch India trips for the new section
  useEffect(() => {
    // Use fetchTripsByCategory for domestic trips
    fetchTripsByCategory('india')
      .then(setIndiaTrips)
      .catch(() => setIndiaTrips([]));
  }, []);

  // Function to close the contact card
  const handleCloseContactCard = () => {
    setShowContactCard(false);
  };

  return (
    <>
      {/* Contact Card Overlay */}
      {showContactCard && (
        <div
          className="contact-card-overlay"
          onClick={handleCloseContactCard} // Close when clicking the overlay
        >
          <div
            className="contact-card-container"
            onClick={(e) => e.stopPropagation()} // Prevent clicks on the card from closing it
          >
            <ContactCard
              isOverlay={true}
              onClose={handleCloseContactCard}
            />
          </div>
        </div>
      )}

      <Hero />

      <DesktopCategories />
      <ExploreWorldCategories />
      <UpcomingTrips />
      <BannerSection />

      {/* Domestic Trips Section */}
      <div className="container" style={{ marginTop: '2rem', marginBottom: '1rem' }}>
        <h2 className="section-title">Domestic Trips</h2>
      </div>
      <UpcomingTrips
        hideControls={true}
        trips={indiaTrips}
        loading={loading}
      />

      <Plans />

      {/* <Packages categoryTitle="Upcoming Tours" data={upcomingTours} loading={loading} /> */}
      {/* <Packages categoryTitle="Popular Destinations" data={popularDestinations} loading={loading} /> */}
      {/* <Packages categoryTitle="Group Tours" data={groupTours} loading={loading} /> */}
      {/* <Packages categoryTitle="Backpack Tours" data={backpackTours} loading={loading} /> */}

      <About />

      <LogoSection />

      <Testimonials />

      <Gallery />

      <Footer />

      <Whatsapp />
    </>
  );
};

export default Home;